import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutGrid, Cpu, Folders, Activity, BellRing, Sparkles, Cloud, LogOut,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const navItems = [
  { to: "/dashboard", label: "Overview", icon: LayoutGrid, testid: "nav-dashboard" },
  { to: "/devices", label: "Devices", icon: Cpu, testid: "nav-devices" },
  { to: "/groups", label: "Groups", icon: Folders, testid: "nav-groups" },
  { to: "/telemetry", label: "Telemetry", icon: Activity, testid: "nav-telemetry" },
  { to: "/alerts", label: "Alerts", icon: BellRing, testid: "nav-alerts" },
  { to: "/insights", label: "AI Insights", icon: Sparkles, testid: "nav-insights" },
  { to: "/settings/aws", label: "AWS IoT", icon: Cloud, testid: "nav-aws" },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FCFCFC] text-[#0A0A0A] flex" data-testid="dashboard-layout">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-neutral-200 bg-white flex flex-col">
        <button
          onClick={() => navigate("/")}
          data-testid="brand-link"
          className="px-5 py-5 border-b border-neutral-200 text-left hover:bg-neutral-50"
        >
          <div className="label-eyebrow text-neutral-500">Quantzillion</div>
          <div className="font-display font-black tracking-tighter text-2xl leading-none mt-1">IoT // CONTROL</div>
        </button>

        <nav className="flex-1 py-3">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-5 py-3 text-sm border-l-2 transition-colors ${
                  isActive
                    ? "border-[#002FA7] bg-neutral-50 text-[#0A0A0A] font-semibold"
                    : "border-transparent text-neutral-600 hover:text-[#0A0A0A] hover:bg-neutral-50"
                }`
              }
            >
              <it.icon className="w-4 h-4" strokeWidth={1.75} />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-neutral-200 p-4">
          <div className="flex items-center gap-3">
            {user?.picture ? (
              <img src={user.picture} alt="" className="w-8 h-8 rounded-sm border border-neutral-200" />
            ) : (
              <div className="w-8 h-8 bg-neutral-200 rounded-sm" />
            )}
            <div className="min-w-0 flex-1">
              <div className="text-xs font-semibold truncate" data-testid="user-name">{user?.name}</div>
              <div className="text-[11px] text-neutral-500 truncate font-mono">{user?.email}</div>
            </div>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="p-2 hover:bg-neutral-100"
              title="Log out"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.75} />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
